import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/job'
const api = createApi(baseUrl)

// 用户相关API
export const articleJobApi = {
  insert: api('insert', 'post'),
  list: api('list', 'get'),
  detail: api('detail', 'get'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
}